(function (t) {
// pl
t.add("label_previous", "Poprzednia", "KnpPaginatorBundle", "pl");
t.add("label_next", "Nast\u0119pna", "KnpPaginatorBundle", "pl");
})(Translator);
